import { type Extension, RangeSetBuilder } from "@codemirror/state";
import { Decoration, type DecorationSet, type EditorView, ViewPlugin, type ViewUpdate } from "@codemirror/view";
import { modifierRegex } from "../regex";




const modifierLine = Decoration.line({
  attributes: { class: "qp-modifier" },
});

function modifierDeco(view: EditorView) {
  const builder = new RangeSetBuilder<Decoration>();
  for (const { from, to } of view.visibleRanges) {
    for (let pos = from; pos <= to;) {
      const line = view.state.doc.lineAt(pos);
      const modMatch = modifierRegex.test(line.text);
      if (modMatch) {
        builder.add(line.from, line.from, modifierLine);
      }

      pos = line.to + 1;
    }
  }

  return builder.finish();
}

const showModifierLines = ViewPlugin.fromClass(
  class {
    decorations: DecorationSet;

    constructor(view: EditorView) {
      this.decorations = modifierDeco(view);
    }

    update(update: ViewUpdate) {
      if (update.docChanged || update.viewportChanged) {
        this.decorations = modifierDeco(update.view);
      }
    }
  },
  {
    decorations: v => v.decorations,
  },
);

export function markModifierLines(): Extension {
  return [
    showModifierLines,
  ];
}
